import React from 'react';
import styled from 'styled-components';
import Colors from '../../../../styles/colors';
import { FlexDiv } from '../../../../styles/styled';

const RatingBar = props => {
  const { stars, percent } = props;
  return (
    <FlexDiv justifyContent="space-between">
      <BarStars>
        <span>{`${stars} stars`}</span>
      </BarStars>
      <div>
        <BarContainer>
          <BarFiller width={percent} />
        </BarContainer>
        <BarLabel>
          <span>{`${percent}%`}</span>
        </BarLabel>
      </div>
    </FlexDiv>
  );
};

const BarContainer = styled.div`
  display: inline-block;
  height: 8px;
  width: 200px;
  background-color: rgba(94, 94, 94, 0.14);
  border-radisu: 50;
`;

const BarStars = styled.div`
  flex: 1;

  span {
    margin-right: 10px;
  }
`;

const BarFiller = styled.div`
  height: 100%;
  width: ${props => (props.width ? props.width : 0)}%;
  background-color: ${Colors.mainOrange};
  transition: width 1s ease-in-out;
  border-radius: inherit;
  text-align: right;
`;

const BarLabel = styled.div`
  display: inline-block;
  width: 32px;
  font-style: italic;
  text-align: right;
  opacity: 0.5;
`;

export default RatingBar;
